import type { Simulation } from '../../sim/simulation';

type AnyFn = (...args: unknown[]) => unknown;

/**
 * Head to head (docs/HEAD_TO_HEAD.md): the match as one seat sees it, for drawing code written for
 * one mower (`LevelView`, the HUD). Its `mower`, `crossTicks()`, turn preview and the like are that
 * seat's; the lawn, coins and the rest are the match's. Read only.
 */
export function seatView(sim: Simulation, seat: number): Simulation {
  if (seat === 0) return sim;
  const proto = Object.getPrototypeOf(sim) as object;
  return new Proxy(sim, {
    get(target, prop, receiver): unknown {
      const descriptor = Object.getOwnPropertyDescriptor(proto, prop);
      // A getter (the mower, its status) answers as the seat.
      if (descriptor?.get) {
        return target.asSeat(seat, (): unknown => Reflect.get(proto, prop, target));
      }
      const value: unknown = Reflect.get(target, prop, receiver);
      if (typeof value !== 'function') return value;
      const method = value as AnyFn;
      return (...args: unknown[]): unknown =>
        target.asSeat(seat, (): unknown => method.apply(target, args));
    },
  });
}
